// Campos simples do painel, com o texto por omissão da EKKO a cinzento quando estão vazios
import { EKKO_DEFAULTS } from "@/lib/ekkoDefaults";
import { stripHtml } from "@/lib/text";

const INPUT = "w-full bg-[#141414] border border-[#3A3A3A] rounded px-3 py-2 text-[#F5F5F5] text-sm";

export function Box({ title, icon: Icon, hint, children }) {
  return (
    <div className="bg-[#1F1F1F] rounded-lg p-4 border border-[#3A3A3A]">
      <h3 className="text-[#A6C48A] font-bold mb-1 flex items-center gap-2">
        {Icon && <Icon size={18} />} {title}
      </h3>
      {hint && <p className="text-[#8A8A8A] text-xs mb-3">{hint}</p>}
      <div className="space-y-4 mt-3">{children}</div>
    </div>
  );
}

export function TextField({ label, field, content, setContent, multiline = false, rows = 3, placeholder }) {
  const props = {
    value: content[field] || "",
    onChange: (e) => setContent((prev) => ({ ...prev, [field]: e.target.value })),
    placeholder: placeholder ?? (typeof EKKO_DEFAULTS[field] === "string" ? stripHtml(EKKO_DEFAULTS[field]) : ""),
    className: INPUT,
  };
  return (
    <div>
      <label className="block text-[#A1A1AA] text-xs mb-1">{label}</label>
      {multiline ? <textarea rows={rows} {...props} /> : <input {...props} />}
    </div>
  );
}

export const inputClass = INPUT;
